var lib_core  = require("lib-core");

var AbstractEditorController = require("./../../abstract/abstractEditorController.js");
var DraggingStateMachine = require("./draggingStateMachine.js");
var DraggingModel        = require("./draggingModel.js");
// var DraggingView         = require("./draggingView.js");

var DraggingController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);

    lib_core.GuiEvents.addEvents({
        UI_DRAG_MOUSE_DOWN: {id: 'ui_01', name: "UI_DRAG_MOUSE_DOWN" }
    });
};
lib_core.inherit(DraggingController, lib_core.Controller);
DraggingController.inject = {
    abstractEditorController : AbstractEditorController
};

module.exports = DraggingController;

DraggingController.prototype.createStateMachine = function () {
    return new DraggingStateMachine(this.root, this.getModel());
};

DraggingController.prototype.createModel = function () {
    return new DraggingModel();
};

// DraggingController.prototype.createView = function() {
//     return new DraggingView(this.getModel(), this.getStatemachine());
// };

DraggingController.prototype.afterLoad = function () {
    this.abstractEditorController.getStatemachine().append('dragging', this.getStatemachine(), 'idle', null, 'idle', null);
};
